

















  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {DataImageObj} from './MiniTileComp.vue';

  @Component
export default class ImageGallery extends Vue {

  @Prop({ type: Array }) private images?: Array<DataImageObj>;
  @Prop() private image?: DataImageObj;
  @Prop() private thumb?: DataImageObj;

  private id?: string = '';

  private get imagesForGallery() {
    if (this.image) {
      return [this.image];
    }

    return this.images || [];
  }

  private get thumbImage() {
    if(this.thumb) {
      return this.thumb;
    }
    if(this.imagesForGallery.length > 0) {
      return this.imagesForGallery[0];
    }

    return null;
  }

  mounted() {
    this.id = 'g' + Math.floor(Math.random() * 100000);
    ($(".fancybox") as any).fancybox({
      smallBtn: true,
      //   protect: true,
      toolbar: false,
      idleTime: false,
      clickContent: false,
      animationEffect: 'slide',
      afterLoad: (fb: any, slide: any) => {
          if(fb.group.length > 1) {
            slide.$content.append(`<div class="gallery-slide-page">${slide.pos + 1} / ${fb.group.length}</div>`);
          }
      }
    });
  }
}

